import api from './api'
import type {
  CreditBoxResponse,
  GoldenDealTraceResponse,
  GoldenReconMatrix,
  WhatIfMissingResponse,
} from '@/types'

export const reconciliationService = {
  // Live golden-deal reconciliation, computed server-side from the frozen fixtures.
  getMatrix: () =>
    api.get<GoldenReconMatrix>('/golden-deal-reconciliation/').then((r) => r.data),

  // Full stage-by-stage run for one golden deal: source anchors, structured
  // record, independent recomputation, credit-box screen, verdict.
  getTrace: (model: string) =>
    api
      .get<GoldenDealTraceResponse>(`/golden-deal-reconciliation/trace/${model}`)
      .then((r) => r.data),

  // Sandbox: re-screen with a required input withheld. Nothing persisted.
  getWhatIfMissing: (model: string, field: string) =>
    api
      .get<WhatIfMissingResponse>(
        `/golden-deal-reconciliation/trace/${model}/what-if-missing`,
        { params: { field } },
      )
      .then((r) => r.data),

  // The versioned ruleset every deal is screened against, with artifact hash.
  getCreditBox: () =>
    api
      .get<CreditBoxResponse>('/golden-deal-reconciliation/credit-box')
      .then((r) => r.data),
}
